import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserType } from '../auth.models';

export interface CompleteProfileConfig {
  userType: UserType;
  redirectUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class CompleteProfileService {
  private readonly config$$ = new BehaviorSubject<CompleteProfileConfig | null>(null);
  readonly config$ = this.config$$.asObservable();

  open(config: CompleteProfileConfig): void {
    this.config$$.next(config);
  }

  close(): void {
    this.config$$.next(null);
  }
}
